<ng-template #expandCollapseFilterButton>
  <ap-button
    btnType="secondary"
    styleClass="ap-pl-spacing-2 ap-pr-spacing-2"
    (onClick)="toggleHandler()">
    @if (hasFilter()) {
      <span class="Appkit4-icon icon-filter-fill"></span>
    } @else {
      <span class="Appkit4-icon icon-filter-outline"></span>
    }
    @if (isCollapse()) {
      <span class="Appkit4-icon icon-down-chevron-outline ap-font-12"></span>
    } @else {
      <span class="Appkit4-icon icon-up-chevron-outline ap-font-12"></span>
    }
  </ap-button>
</ng-template>

<div
  class="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-2">
  <div class="d-inline-flex align-items-center gap-2">
    <ng-content select="[start-toolbar]" />
    <ng-container *ngTemplateOutlet="expandCollapseFilterButton" />
  </div>

  <div class="d-inline-flex align-items-center gap-2">
    <ng-content select="[center-toolbar]" />
  </div>

  <div class="d-inline-flex align-items-center gap-2">
    <ng-content select="[end-toolbar]" />
  </div>
</div>
